import BaseClient from '@/app/model/api/response/baseApiClient'

class ProfitResultListApi extends BaseClient {
  public getResultList (year: string, season: string) {
    const path:string = '/v1/profit/results/list'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ year: year, season: season })
    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new ProfitResultListApi()
